// booking.lang.en.js
const bookingEN = {
	weekLabel: "{start} – {end}",
	week: {
		previous: "Previous week",
		next: "Next week",
	},
	noSlots: "No available times",
	staff: {
		title: "Choose Your Professional",
		any: "Any staff",
	},
	services: {
		title: "Confirm Your Services",
		add: "+ Add Service",
		selected: "{name} • {duration} min — ${price}",
		remove: "Remove service",
		notMixable: " (Not mixable)",
		lockedHome: "Only home services can be added to this booking.",
		lockedShop: "Only in-shop services can be added to this booking.",
		cantMix: "You can't mix home services with in-shop services.",
	},
	serviceType: {
		home: "Home service",
		online: "Online",
	},
	home: {
		title: "Home service details",
		extraDetails: "Additional details (optional) — apt, landmark, etc.",
	},
	guest: {
		title: "Your Details",
		fullName: "Full Name",
		email: "Email",
	},
	contact: {
		title: "Contact number",
		hint: "We don't have a phone number on your account — the shop needs one to reach you about this booking.",
	},
	steps: {
		book: "Appointment",
		when: "Date & time",
		review: "Review",
	},
	stepHints: {
		book: "Pick your services, a time that works, and how the shop reaches you.",
		review: "One last look, then we send it over.",
	},
	review: {
		title: "Review & confirm",
		where: "Where",
		when: "When",
		professional: "Professional",
		services: "Services",
		contact: "Contact",
		total: "Total",
		atShop: "At the shop",
		homeVisit: "At your address",
	},
	buttons: {
		confirm: "Confirm Booking",
		confirmReschedule: "Confirm Reschedule",
		next: "Next",
		back: "Back",
		close: "Close",
	},
	toast: {
		noServiceOrTime: "Please pick at least one service and a time",
		missingService: "Please select at least one service.",
		missingTime: "Please select a time.",
		missingGuest: "Please provide your name, email and phone number",
		missingPhone: "Please add a phone number so the shop can reach you.",
		noStaff: "No staff available for that time",
		pastTime: "That time has already passed. Please choose another time.",
		bookingConfirmed: "You're all set! Your booking is confirmed and we sent you a confirmation email.",
		rescheduled: "All set! Your booking has been rescheduled.",
		couldNotReschedule: "We couldn't reschedule your booking. Please try again.",
		couldNotConfirm: "We couldn't confirm your booking. Please try again.",
		timeInvalidated: "The selected time is no longer available for the chosen services.",
		missingStaff: "Please pick atleast one staff",
		missingAddress: "Please enter a valid address for the home service.",

	},
	timeFilters: {
		morning: "Morning",
		afternoon: "Afternoon",
		evening: "Evening",
	},
	summary: {
		noServices: "No services selected",
		oneService: "1 service",
		multipleServices: "{n} services",
	},
};

export default bookingEN;
